// Global dialogs that open on their own (the passkey prompt, the install offer) must not stack:
// two masks at the same z-index leave the client clicking one dialog through another. A dialog
// that is on screen, or still deciding whether to open, holds the gate; the polite ones wait.
//
// Module state rather than recoil: the passkey prompt decides inside an async effect, and a plain
// store keeps this importable from tests without the apollo/axios graph behind the dialogs.

const holders = new Map();
let version = 0;
const listeners = new Set();

const notify = () => {
    version += 1;
    listeners.forEach((listener) => listener());
};

export const subscribe = (listener) => {
    listeners.add(listener);

    return () => listeners.delete(listener);
};

export const getVersion = () => version;

/** Holds the gate for `key`. Returns the release; releasing twice is harmless. */
export const holdDialog = (key) => {
    const token = Symbol(key);

    holders.set(token, key);
    notify();

    return () => {
        if (holders.delete(token)) notify();
    };
};

export const isDialogHeld = () => holders.size > 0;

/** Held by someone other than `key`: a dialog's own hold must not keep it waiting on itself. */
export const isDialogHeldByOthers = (key) => [...holders.values()].some((holder) => holder !== key);

/** The keys holding the gate, for debugging. */
export const dialogHolders = () => [...holders.values()];
